import React, { useState, useEffect } from 'react'
import useSliceCards from '../../holdem/helpers/sliceCard'
import { BetReplyFooter } from '../footer/positions/PositionStyles'
import { texts } from 'components/footer/text/contents'
import GameBoard from '../gameBoard/GameBoard'
import PositionsWrapper from '../footer/positions/PositionsWrapper'
import BetInfoWrapper from './BetInfo'
import Text from '../footer/text/Text'

const CustomReply = ({ betReplyResponse, precision }: any) => {
  const {
    cards,
    state,
    aa,
    ante,
    raise,
    winAmount,
    currency,
    playerWinPositions,
    dealerWinPositions,
    playerWinType,
    dealerWinType,
  } = betReplyResponse

  const [dealer, setDealer] = useState<string[]>(['X0', 'X0'])
  const [river, setRiver] = useState<string[]>(['X0', 'X0', 'X0', 'X0', 'X0'])
  const [player, setPlayer] = useState<string[]>(['X0', 'X0'])

  useSliceCards(cards, setPlayer, setRiver, setDealer)

  const [active, setActive] = useState('')

  const isFold = state === 6 && cards[cards.length - 1] === 'X0'
  const empty = ['0', '0', '0', '0', '0', '0', '0', '0', '0']
  const [winCombination, setWinCombination] = useState<string[]>(empty)
  const bets = [
    { title: 'ANTE', content: ante },
    {
      title: 'RAISE',
      content: raise,
    },
    {
      title: 'AA BONUS',
      content: aa,
    },
  ]

  useEffect(() => {
    if (state === 5 || isFold) {
      setWinCombination(playerWinPositions)
    } else if (!isFold && state !== 11) {
      setWinCombination(dealerWinPositions)
    } else {
      setWinCombination(empty)
    }
  }, [playerWinPositions, dealerWinPositions, state])

  return (
    <>
      <Text
        text={texts.dealerTextBetReply(dealerWinType, state)}
        gameState={state}
        noAnimate={true}
        betReply={true}
      />
      <GameBoard
        deal={true}
        dealOut={false}
        showResult={true}
        dealer={dealer}
        player={player}
        river={river}
        dealRiver={true}
        tie={state === 11}
        noAnimate={true}
        winPositions={winCombination}
      />
      <BetReplyFooter>
        <Text
          text={texts.playerTextBetReply(
            playerWinType,
            precision,
            currency,
            winAmount,
            state,
          )}
          gameState={state}
          noAnimate={true}
          betReply={true}
        />
        <PositionsWrapper
          ante={ante.bet}
          AAbonus={aa.bet !== '0' ? aa.bet : 'AA'}
          raise={raise.bet}
          active={active}
          handleActive={setActive}
          gameState={5}
          noAnimate={true}
          betReply={true}
          anteWin={ante.win}
          AAWin={aa.win}
          raiseWin={raise.win}
          currency={currency}
          precision={precision}
        />
      </BetReplyFooter>
      {bets.map((item: any, i: number) => (
        <BetInfoWrapper
          key={i}
          data={item.content}
          title={item.title}
          currency={currency}
          precision={precision}
        />
      ))}
    </>
  )
}

export default CustomReply
